var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeline-item',{attrs:{"type":_vm.type,"title":_vm.title,"date":_vm.date,"by-name":_vm.byName,"icon":"task","color":"is-activities"}})
}
var staticRenderFns = []

export { render, staticRenderFns }